import { z } from "zod";
import { stripSearchParams, type SearchMiddleware } from "@tanstack/react-router";
import {
  defaultPageSearch,
  optionalCalendarDay,
  optionalPage,
  optionalSearch,
} from "./shared";

const financierSortSchema = z.enum([
  "createdAt:asc",
  "createdAt:desc",
  "name:asc",
  "name:desc",
]);

export const financiersSearchDefaults = {
  ...defaultPageSearch,
  sort: "createdAt:desc" as const,
};

export const financiersSearchSchema = z.object({
  nameContains: optionalSearch(z.string()),
  createdAfter: optionalCalendarDay,
  createdBefore: optionalCalendarDay,
  sort: optionalSearch(financierSortSchema),
  page: optionalPage,
});

export type FinanciersSearch = z.infer<typeof financiersSearchSchema>;

export const financiersSearchMiddlewares: SearchMiddleware<FinanciersSearch>[] = [
  stripSearchParams(financiersSearchDefaults) as SearchMiddleware<FinanciersSearch>,
];
